const body = document.querySelector("body");
const launchModalButtonsAll = document.querySelectorAll("._jsLaunchModal");
const modalsAll = document.querySelectorAll(".modalDialog");



// launchModal buttons

launchModalButtonsAll.forEach(launchModal => {
	const modalId = launchModal.getAttribute("aria-controls");
	const modal = document.getElementById(modalId);

	launchModal.addEventListener("click", function() {
		this.setAttribute("aria-expanded", "true");
		modal.removeAttribute("hidden");
		modal.querySelector(".modalInner").focus();
		body.classList.add("hasOpenModal");
	});
});



// modal close, tabTrap etc.

modalsAll.forEach(modal => {
	const modalId = modal.getAttribute("id");
	const closeButton = modal.querySelector("._jsClose");
	const tabTrapsAll = modal.querySelectorAll("._jsTabTrap");
	const launchButton = document.querySelector("[aria-controls=" + modalId + "]");

	// close function

	function closeModal() {
		modal.setAttribute("hidden", "");
		launchButton.setAttribute("aria-expanded", "false");
		launchButton.focus();
		body.classList.remove("hasOpenModal");
	}

	// closeButton

	closeButton.addEventListener("click", function() {
		closeModal();
	});

	// close when pressing escape

	modal.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			closeModal();
		}
	});

	// tabtrap – trap keyboard focus insie – on focus, move focus to closeButton

	tabTrapsAll.forEach(tabTrap => {
		tabTrap.addEventListener("focus", function() {
			closeButton.focus();
		});
	});
});

